import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Breadcrumb({ items = [], onDark = false }) {
  const { to, t } = useLang();
  const base = onDark ? "text-white/60" : "text-nek-gray";
  const active = onDark ? "text-white" : "text-nek-navy";
  return (
    <nav aria-label="Fil d'Ariane" className={`flex flex-wrap items-center gap-1.5 text-sm ${base}`} data-testid="breadcrumb">
      <Link to={to("")} className="inline-flex items-center gap-1 hover:underline">
        <Home className="h-3.5 w-3.5" /> {t.servicePage.breadcrumbHome}
      </Link>
      {items.map((it, i) => (
        <React.Fragment key={`${it.label}-${i}`}>
          <ChevronRight className="h-3.5 w-3.5 opacity-60" />
          {it.path ? (
            <Link to={to(it.path)} className="hover:underline">{it.label}</Link>
          ) : (
            <span className={`font-semibold ${active}`}>{it.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
